//
class ProductService {
  static getBySelector(product_url) {

    return new Promise((resolve, reject) => {
      jQuery.getJSON("/" + product_url + '.js', function(product) {
        resolve(product);
      });
    });
  }
}

class CartService {
  static getItems(timestamp) {
    return new Promise((resolve, reject) => {
      jQuery.getJSON(`/cart.js`)
      .then(res => {
        resolve(res.items)
      })
    });
  }

  static get(timestamp) {
    return new Promise((resolve, reject) => {
      jQuery.ajax({
        type: 'GET',
        url: `/cart?view=drawer&timestamp=${timestamp}&source=custom`,

        success: function(msg) {
          resolve(msg);
        },
        error: function() {
          alert(
            'Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
          reject({message: 'Oops!'});
        },
      });
    });
  }

  static add(id) {
    return new Promise((resolve, reject) => {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: id,
        },
        dataType: 'json',
        success: function(data) {
          resolve(data);
        },
        error: function() {
          alert(
            'Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
          reject({message: 'Oops!'});
        },
      });
    });
  }
    static update(products) {
    return new Promise((resolve, reject) => {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          updates: products
        },
        dataType: 'json',
        success: function(data) {
          resolve(data);
        },
        error: function() {
          alert(
            'Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
          reject({message: 'Oops!'});
        },
      });
    });
  }
    static remove(id, quantity) {
    return new Promise((resolve, reject) => {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          quantity: quantity,
          id: id,
        },
        dataType: 'json',
        success: function(data) {
          resolve(data);
        },
        error: function() {
          alert(
            'Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
          reject({message: 'Oops!'});
        },
      });
    });
  }
    static madd(id, quantity) {
    return new Promise((resolve, reject) => {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: quantity,
          id: id,
        },
        dataType: 'json',
        success: function(data) {
          resolve(data);
        },
        error: function() {
          alert(
            'Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
          reject({message: 'Oops!'});
        },
      });
    });
  }
}


function fetchDrawerRecommendations(productId, recommendationsCount = 3) {

    if (productId == "") {
      var url = `/recommendations/products?section_id=cart-recommendations-section&product_id=${productId}&limit=${recommendationsCount}`;
    } else {
      var url =
     
        "/recommendations/products?section_id=cart-recommendations-section&product_id=" +
        productId +
        "&limit=10";
    }
    return fetch(url);
 
}

function fetchRecommendations(productId, recommendationsCount = 3) {

  if (productId == "") {
  var url = `/recommendations/products?section_id=cart-recommendations-section&product_id=${productId}&limit=${recommendationsCount}`;
  } else {
    var url =
       
        "/recommendations/products?section_id=cart-recommendations-section&product_id=" +
        productId +
        "&limit=10";
  }
  return fetch(url)
}



function renderCartRecommendations(){

  const mobile = isMobile();

  CartService.getItems()
  .then(items => {
    if(Array.isArray(items) && items.length > 0){
      const product = items[0];
      const isCart = window.location.href.includes('/cart');

      if(isCart) return fetchRecommendations(product.product_id);

      return fetchDrawerRecommendations(product.product_id);

    } else if (mobile) {
      rerenderUpsell();
      throw `Array lenght is: ${items.length} and is mobile so I exited here.`;
    } else {
      throw `Array lenght is: ${items.length} so I exited here.`;
    }
  })
  .then(response => response.text().then(recommendations => {

    $('.Upsell__Container').html(recommendations);
    $('#CustomCart__Recommendations').html(recommendations);
    $('.firstCart_featured').css("display", "none");
    
  })).catch(error => { console.log(error)})
}

function changeCartNumberVisibility(currentTotal, newTotal){

  $('.Header__CartNumber').text(newTotal);

  if(currentTotal !== newTotal &&  newTotal > 0){
    $('.Header__CartNumber').css('display', 'block');
    $('.CartIcon__Identity').addClass('Header__CartGlow');

    $('.CartIcon__Identity img').removeClass('icoCartWhite');
    $('.CartIcon__Identity img').addClass('icoCartOrange');

  }else if(currentTotal !== newTotal &&  newTotal === 0){
    $('.Header__CartNumber').css('display', 'none');
    $('.CartIcon__Identity').removeClass('Header__CartGlow');

    $('.CartIcon__Identity img').addClass('icoCartWhite');
    $('.CartIcon__Identity img').removeClass('icoCartOrange');
  }
}


function productAddedToCart(data){
  const addToCart = parseInt(data.detail.quantity);
  const currentTotal = parseInt($('.Header__CartNumber:eq(0)').text());
  const newTotal = currentTotal + addToCart;
  changeCartNumberVisibility(currentTotal, newTotal);

  if($('#CustomCart__Recommendations').length != 0){
    renderCartRecommendations();

  }

  if($('#mobileRecommendations').length != 0){
    renderCartRecommendations();
  
  }
}

const generateUpsellItemCheckedId = (id) => `UpsellItem_Checked${id}`;
const generateUpsellItemSelectorId = (id) => `UpsellItem_Selector${id}`;

function addtocart_custom(selectedProductId, product_url) {

  const loadingBar = $('.LoadingBar')

  loadingBar.addClass('is-visible');
  loadingBar.css('width', '40%');

  // -- We have the product url now, and declared a variable for the id which we will set later
  // -- now we are getting the products JSON object, which we need to push to the cart

  ProductService.getBySelector(`${product_url.replace('/','')}`).then(product => {

    const upsellElementOld = $('.cart-upsell');
   
    if(!product.variants || !Array.isArray(product.variants) || product.variants.length === 0)
    {
      product = product.product;

      if(!product.variants || !Array.isArray(product.variants) || product.variants.length === 0){
        return;
      }
    }

    const variantId = product.variants[0].id;
    CartService.add(variantId).then(cart => {
      if (cart) {
        loadingBar.css('width', '80%');
        
        CartService.get(Date.now()).then(cart => {

          const cartElement = $($.parseHTML(cart));
          const drawerElement = cartElement.find('form');

          upsellElementOld.find(`#${generateUpsellItemCheckedId(selectedProductId)}`).removeClass('Item__Invisible')
          upsellElementOld.find(`#${generateUpsellItemSelectorId(selectedProductId)}`).addClass('Item__Invisible')
          drawerElement.find('.cart-upsell').replaceWith(upsellElementOld);

          const drawerHtml = drawerElement.html();

          const cartFormElement = $('#sidebar-cart').find('form');
          cartFormElement.html(drawerHtml);

          loadingBar.css('width', '100%');
          loadingBar.addClass('is-finished');


          /*Send custom event*/
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: product.variants[0],
              quantity: 1
            }
          }));

          document.dispatchEvent(new CustomEvent('product:added_custom', {
            bubbles: true,
            detail: {
              variant: product.variants[0],
              quantity: 1
            }
          }))

        });

      }
    });
  });

  
}

//Custom cart event
document.addEventListener('product:added_custom', function(data){

  productAddedToCart(data);
  
});



function rerenderUpsell(){
   if (!isMobile()) {
    $.get( "/?section_id=custom_rec_cart", function( data ) {
      $('#CustomCart__Recommendations').html(data);
    });
 
   } else {
    $.get( "/?section_id=custom_rec_cart_m", function( data ) {
      $('#CustomCart__Recommendations').html(data);
    });
   }
}